import moment from "moment";
export const isWindows = () => navigator.platform.indexOf("Win") > -1;

export const divideToRowCol = (num) => {
  const cols = Math.ceil(Math.sqrt(num));
  const rows = Math.ceil(num / cols);

  return [rows, cols];
};

export const limitNumberOfCalls = (limit, callback, defaultRet) => {
  var numCalled = limit;

  return (...args) => {
    if (callback !== undefined) {
      const retval = callback(...args);
      numCalled -= 1;
      if (numCalled === 0) {
        callback = undefined;
      }
      return retval;
    }
    return typeof defaultRet === "function" ? defaultRet() : defaultRet;
  };
};

export const extractErrorMessage = (err) => {
  if (
    err &&
    err.response &&
    err.response.data &&
    err.response.data.message &&
    err.response.data.dateTime
  ) {
    console.log(err.response.data.message);
    console.log("DAte" + err.response.data.dateTime);
    const startAllowed = moment(err.response.data.dateTime).toDate();
    const startAllowed2 = new Date(err.response.data.dateTime).toLocaleString();
    console.log("start Allowed" + startAllowed);
    console.log("start Allowed2" + startAllowed2);

    //return err.response.data.message;
    return `You can join this meeting after ${startAllowed2}`;
  }
  if (err && err.response && err.response.data && err.response.data.message) {
    console.log(err.response.data.message);
    return err.response.data.message;
  }

  if (err && err.message) {
    console.log("Error" + err.message);
    return err.message;
  }

  return "Unknown Error";
};

export const removeNullsFromAppt = (appointment) => {
  const formattedAppt = { ...appointment };
  const trailingDash = /-$/;
  Object.keys(appointment).forEach((key) => {
    if (appointment[key] === null) {
      formattedAppt[key] = "N/A";
    }
    if (appointment[key] && appointment[key] !== null) {
      let valueString = appointment[key].toString();
      let found = valueString.match(trailingDash);
      if (found !== null) {
        formattedAppt[key] = appointment[key].replace(trailingDash, "");
      }
    }
  });
  return formattedAppt;
};
